import YDropdown from './src/main'

YDropdown.install = function(Vue) {
  Vue.component(YDropdown.name, YDropdown)
}

export default YDropdown
